export default "__VITE_ASSET__9c6b0956__"